/**
 * GRUPO COMZA — comza-lightbox.js (v5)
 * No invasivo — se adjunta a tarjetas existentes de Impact
 *
 * CHANGES v5:
 *   - cfg() ahora se usa para leer textos configurables
 *     desde document.documentElement.dataset (inyectados
 *     por comza-theme-vars.liquid).
 *   - data-comza-stock reemplaza a data-comza-sold (más claro:
 *     true = hay stock, false = agotado).
 *   - Lectura de imágenes desde <script type="application/json">
 *     adyacente al <product-card>, robusto ante alts con comillas.
 *   - Focus trap dentro del lightbox cuando está abierto.
 *   - Eliminado código muerto.
 */
(function () {
  'use strict';

  /* ── Lectura de settings inyectados desde Liquid ── */
  function cfg(key, fallback) {
    return document.documentElement.dataset[key] || fallback;
  }

  /* ── Crear lightbox HTML ── */
  function createLightbox() {
    if (document.getElementById('comza-lb')) return;
    var el = document.createElement('div');
    el.id = 'comza-lb';
    el.className = 'comza-lb';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.innerHTML = '<div class="comza-lb__box" id="comzaBox">'
      + '<div class="comza-lb__img-area" id="comzaImgArea">'
        + '<div class="comza-lb__img-wrap" id="comzaImgWrap">'
          + '<img class="comza-lb__img" id="comzaImg" src="" alt="" draggable="false"/>'
          + '<div class="comza-lb__sold-ov" id="comzaSoldOv" hidden>'
            + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>'
            + '<span id="comzaSoldText"></span>'
          + '</div>'
        + '</div>'
        + '<button class="comza-lb__close" id="comzaClose" aria-label="Cerrar">'
          + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
        + '</button>'
        + '<button class="comza-lb__arrow comza-lb__arrow--prev" id="comzaPrev" aria-label="Anterior" disabled>'
          + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>'
        + '</button>'
        + '<button class="comza-lb__arrow comza-lb__arrow--next" id="comzaNext" aria-label="Siguiente">'
          + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>'
        + '</button>'
      + '</div>'
      + '<div class="comza-lb__panel">'
        + '<div class="comza-lb__panel-top">'
          + '<p class="comza-lb__title" id="comzaTitle"></p>'
          + '<span class="comza-lb__counter" id="comzaCounter"></span>'
        + '</div>'
        + '<div class="comza-lb__thumbs" id="comzaThumbs"></div>'
        + '<div class="comza-lb__panel-bottom">'
          + '<div class="comza-lb__price-group">'
            + '<div class="comza-lb__price-row">'
              + '<span class="comza-lb__price" id="comzaPrice"></span>'
              + '<span class="comza-lb__price-compare" id="comzaCompare"></span>'
            + '</div>'
            + '<span class="comza-lb__save" id="comzaSave" hidden></span>'
          + '</div>'
          + '<a class="comza-lb__cta" id="comzaCta" href="#">'
            + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>'
            + '<span id="comzaCtaText"></span>'
          + '</a>'
        + '</div>'
      + '</div>'
    + '</div>';
    document.body.appendChild(el);
  }

  var state = { images: [], idx: 0, zoomed: false, soldOut: false, touchX: 0, touchY: 0, lastFocus: null };
  var e = {};

  function cacheEls() {
    e.lb       = document.getElementById('comza-lb');
    e.box      = document.getElementById('comzaBox');
    e.imgArea  = document.getElementById('comzaImgArea');
    e.imgWrap  = document.getElementById('comzaImgWrap');
    e.img      = document.getElementById('comzaImg');
    e.soldOv   = document.getElementById('comzaSoldOv');
    e.soldText = document.getElementById('comzaSoldText');
    e.close    = document.getElementById('comzaClose');
    e.prev     = document.getElementById('comzaPrev');
    e.next     = document.getElementById('comzaNext');
    e.title    = document.getElementById('comzaTitle');
    e.counter  = document.getElementById('comzaCounter');
    e.thumbs   = document.getElementById('comzaThumbs');
    e.price    = document.getElementById('comzaPrice');
    e.compare  = document.getElementById('comzaCompare');
    e.save     = document.getElementById('comzaSave');
    e.cta      = document.getElementById('comzaCta');
    e.ctaText  = document.getElementById('comzaCtaText');
  }

  function renderSlide(idx) {
    var img = state.images[idx];
    if (!img) return;
    state.idx = idx;
    state.zoomed = false;
    e.imgWrap.classList.remove('is-zoomed');
    e.imgArea.classList.remove('is-zoomed');
    e.img.src = img.src;
    e.img.alt = img.alt || '';
    e.soldOv.hidden = !(state.soldOut && idx === 0);
    e.counter.textContent = (idx + 1) + ' / ' + state.images.length;
    e.prev.disabled = idx === 0;
    e.next.disabled = idx === state.images.length - 1;
    e.thumbs.querySelectorAll('.comza-lb__thumb').forEach(function(t, i) {
      t.classList.toggle('is-active', i === idx);
    });
  }

  function buildThumbs() {
    e.thumbs.innerHTML = '';
    state.images.forEach(function(img, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'comza-lb__thumb' + (i === 0 ? ' is-active' : '');
      btn.setAttribute('aria-label', 'Ver imagen ' + (i + 1));
      var im = document.createElement('img');
      im.src = img.thumb || img.src;
      im.alt = '';
      im.loading = 'lazy';
      btn.appendChild(im);
      btn.addEventListener('click', function(ev) { ev.stopPropagation(); renderSlide(i); });
      e.thumbs.appendChild(btn);
    });
  }

  function openLb(data) {
    state.images    = data.images;
    state.soldOut   = data.soldOut;
    state.idx       = 0;
    state.zoomed    = false;
    state.lastFocus = document.activeElement;

    e.title.textContent    = data.title;
    e.price.textContent    = data.price;
    e.price.className      = 'comza-lb__price' + (data.soldOut ? ' comza-lb__price--muted' : '');
    e.compare.textContent  = data.compare || '';
    e.compare.hidden       = !data.compare;
    e.soldText.textContent = cfg('comzaSoldOutText', 'Agotado');

    if (data.save) {
      e.save.textContent = cfg('comzaSavePrefix', 'Ahorra') + ' ' + data.save;
      e.save.hidden = false;
    } else {
      e.save.hidden = true;
    }

    if (data.soldOut) {
      e.cta.className = 'comza-lb__cta comza-lb__cta--disabled';
      e.cta.removeAttribute('href');
      e.ctaText.textContent = cfg('comzaSoldOutCta', 'Sin existencia por el momento');
    } else {
      e.cta.className = 'comza-lb__cta';
      e.cta.href = data.url;
      e.ctaText.textContent = cfg('comzaLbCtaText', 'Ir a página del producto');
    }

    buildThumbs();
    renderSlide(0);
    e.lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function() { e.close.focus(); });
  }

  function closeLb() {
    e.lb.classList.remove('is-open');
    document.body.style.overflow = '';
    state.zoomed = false;
    e.imgWrap.classList.remove('is-zoomed');
    e.imgArea.classList.remove('is-zoomed');
    if (state.lastFocus && typeof state.lastFocus.focus === 'function') {
      try { state.lastFocus.focus(); } catch (err) {}
    }
  }

  function nav(dir) {
    var n = state.idx + dir;
    if (n < 0 || n >= state.images.length) return;
    renderSlide(n);
  }

  function toggleZoom() {
    state.zoomed = !state.zoomed;
    e.imgWrap.classList.toggle('is-zoomed', state.zoomed);
    e.imgArea.classList.toggle('is-zoomed', state.zoomed);
  }

  /* ── Focus trap ── */
  function getFocusableEls() {
    var sel = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.prototype.slice.call(e.lb.querySelectorAll(sel));
  }

  function handleTabKey(ev) {
    var focusables = getFocusableEls();
    if (focusables.length === 0) return;
    var first = focusables[0];
    var last  = focusables[focusables.length - 1];
    if (ev.shiftKey && document.activeElement === first) {
      ev.preventDefault();
      last.focus();
    } else if (!ev.shiftKey && document.activeElement === last) {
      ev.preventDefault();
      first.focus();
    }
  }

  function bindLbEvents() {
    e.lb.addEventListener('click', function(ev) { if (ev.target === e.lb) closeLb(); });
    e.close.addEventListener('click', closeLb);
    e.prev.addEventListener('click', function(ev) { ev.stopPropagation(); nav(-1); });
    e.next.addEventListener('click', function(ev) { ev.stopPropagation(); nav(1); });
    e.imgArea.addEventListener('click', function(ev) {
      if (ev.target === e.imgArea || ev.target === e.imgWrap || ev.target === e.img) toggleZoom();
    });

    document.addEventListener('keydown', function(ev) {
      if (!e.lb.classList.contains('is-open')) return;
      if (ev.key === 'ArrowLeft')  nav(-1);
      if (ev.key === 'ArrowRight') nav(1);
      if (ev.key === 'Escape')     closeLb();
      if (ev.key === 'Tab')        handleTabKey(ev);
    });

    e.imgArea.addEventListener('touchstart', function(ev) {
      state.touchX = ev.changedTouches[0].screenX;
      state.touchY = ev.changedTouches[0].screenY;
    }, { passive: true });

    e.imgArea.addEventListener('touchend', function(ev) {
      var dx = ev.changedTouches[0].screenX - state.touchX;
      var dy = ev.changedTouches[0].screenY - state.touchY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) nav(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* ══════════════════════════════════
     LÓGICA NO INVASIVA
     ══════════════════════════════════ */

  function getHighResSrc(img) {
    if (!img.srcset) return img.src || '';
    var best = null, bestW = 0;
    img.srcset.split(',').forEach(function(part) {
      var s = part.trim().split(/\s+/);
      var w = s[1] ? parseInt(s[1]) : 0;
      if (w > bestW && s[0]) { bestW = w; best = s[0]; }
    });
    return best || img.src || '';
  }

  function getMedResSrc(img) {
    if (!img.srcset) return img.src || '';
    var candidates = [];
    img.srcset.split(',').forEach(function(part) {
      var s = part.trim().split(/\s+/);
      var w = s[1] ? parseInt(s[1]) : 0;
      if (s[0]) candidates.push({ url: s[0], w: w });
    });
    candidates.sort(function(a, b) { return a.w - b.w; });
    var thumb = candidates.find(function(c) { return c.w >= 400; });
    return thumb ? thumb.url : (candidates[0] ? candidates[0].url : img.src);
  }

  /*
   * Estrategia de extracción de imágenes (en orden):
   *   1. <script type="application/json" data-comza-media-for="HANDLE">
   *      adyacente al <product-card>. Robusto ante alts con comillas.
   *   2. Atributo data-comza-media (legacy, retro-compatible).
   *   3. Fallback: imágenes visibles en la figura, vía srcsets.
   */
  function extractImages(card, figure) {
    var images = [];
    var seen = {};

    // 1. Script JSON adyacente
    var handle = card.getAttribute('handle');
    if (handle) {
      var jsonScript = document.querySelector('script[type="application/json"][data-comza-media-for="' + handle + '"]');
      if (jsonScript) {
        try {
          var parsed = JSON.parse(jsonScript.textContent);
          if (Array.isArray(parsed)) {
            parsed.forEach(function(m) {
              if (!m.src || seen[m.src]) return;
              seen[m.src] = true;
              images.push({ src: m.src, thumb: m.thumb || m.src, alt: m.alt || '' });
            });
            if (images.length > 0) return images;
          }
        } catch (err) {
          // sigue al siguiente método
        }
      }
    }

    // 2. data-comza-media legacy
    var mediaData = card.dataset.comzaMedia;
    if (mediaData) {
      try {
        var parsed2 = JSON.parse(mediaData);
        if (Array.isArray(parsed2)) {
          parsed2.forEach(function(m) {
            if (!m.src || seen[m.src]) return;
            seen[m.src] = true;
            images.push({ src: m.src, thumb: m.thumb || m.src, alt: m.alt || '' });
          });
          if (images.length > 0) return images;
        }
      } catch (err) {}
    }

    // 3. Fallback: srcsets de la figura
    figure.querySelectorAll('img').forEach(function(img) {
      var src = getHighResSrc(img);
      if (!src || seen[src]) return;
      seen[src] = true;
      images.push({ src: src, thumb: getMedResSrc(img), alt: img.alt || '' });
    });

    return images;
  }

  function cleanPrice(el) {
    if (!el) return '';
    var clone = el.cloneNode(true);
    clone.querySelectorAll('.sr-only, [aria-hidden]').forEach(function(n){ n.remove(); });
    return clone.textContent.replace(/Precio\s+de\s+oferta/gi,'')
      .replace(/Precio\s+normal/gi,'')
      .replace(/Sale\s+price/gi,'')
      .replace(/Regular\s+price/gi,'')
      .replace(/\s+/g,' ').trim();
  }

  function extractPricing(card) {
    var price = '', compare = '', save = '';

    var saleEl    = card.querySelector('sale-price');
    var compareEl = card.querySelector('compare-at-price');

    if (saleEl)    price   = cleanPrice(saleEl);
    if (compareEl) compare = cleanPrice(compareEl);

    if (!price) {
      var hlEl = card.querySelector('.price--highlight');
      if (hlEl) price = cleanPrice(hlEl);
    }

    if (!compare) {
      var strikeEl = card.querySelector('s .price, del .price, s[class*="price"], .price--compare');
      if (strikeEl) compare = cleanPrice(strikeEl);
    }

    if (price && compare && price !== compare) {
      var toNum = function(s) { return parseFloat(s.replace(/[^0-9.]/g, '')); };
      var pNum = toNum(price), cNum = toNum(compare);
      if (!isNaN(pNum) && !isNaN(cNum) && cNum > pNum) {
        var diff = cNum - pNum;
        save = diff.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        var sym = price.match(/[^\d\s.,]+/);
        if (sym) save = sym[0] + ' ' + save;
      }
    }

    return { price: price, compare: compare, save: save };
  }

  /*
   * isSoldOut — lee data-comza-stock (true = hay stock).
   * Si el atributo es 'false' → agotado.
   * Fallback: existencia de .comza-sold-overlay en el DOM.
   */
  function isSoldOut(card) {
    var stockAttr = card.dataset.comzaStock;
    if (stockAttr === 'false') return true;
    if (stockAttr === 'true')  return false;
    // Sin atributo → fallback DOM
    return !!card.querySelector('.comza-sold-overlay');
  }

  function injectGalleryHint(figure) {
    if (figure.querySelector('.comza-gallery-hint')) return;
    var hint = document.createElement('div');
    hint.className = 'comza-gallery-hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>Ver galería';
    figure.appendChild(hint);
  }

  function processCard(card) {
    if (card.dataset.comzaInit) return;
    card.dataset.comzaInit = '1';

    var figure = card.querySelector('.product-card__figure');
    if (!figure) return;

    var images = extractImages(card, figure);
    if (images.length === 0) return;

    var pricing     = extractPricing(card);
    var soldOut     = isSoldOut(card);
    var hasDiscount = !!(pricing.compare && pricing.compare !== pricing.price);

    var titleEl = card.querySelector('.product-card__title a, .product-card__title');
    var title   = titleEl ? titleEl.textContent.trim() : '';
    var linkEl  = card.querySelector('a[href*="/products/"]');
    var url     = linkEl ? linkEl.href : '#';

    injectGalleryHint(figure);
    figure.style.cursor = 'zoom-in';

    figure.addEventListener('click', function(ev) {
      if (ev.target.tagName === 'A') return;
      ev.preventDefault();
      ev.stopPropagation();
      openLb({
        images: images, soldOut: soldOut, title: title, url: url,
        price:   pricing.price,
        compare: hasDiscount ? pricing.compare : '',
        save:    hasDiscount ? pricing.save    : ''
      });
    });
  }

  function processAllCards() {
    document.querySelectorAll('product-card').forEach(processCard);
  }

  function observeCards() {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          if (node.tagName && node.tagName.toLowerCase() === 'product-card') processCard(node);
          if (node.querySelectorAll) node.querySelectorAll('product-card').forEach(processCard);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    createLightbox();
    cacheEls();
    bindLbEvents();
    processAllCards();
    observeCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
